import { EContentFullscreenActionTypes, IContentFullscreenOpenPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const openContentFullscreen = actionGenerator<EContentFullscreenActionTypes.Open, IContentFullscreenOpenPayload>(
  EContentFullscreenActionTypes.Open,
);

export const setContentFullscreen = actionGenerator<EContentFullscreenActionTypes.Set, IContentFullscreenOpenPayload>(
  EContentFullscreenActionTypes.Set,
);

export const closeContentFullscreen = actionGenerator<EContentFullscreenActionTypes.Close, void>(
  EContentFullscreenActionTypes.Close,
);
